module.exports = __webpack_public_path__ + "teqbahn-assets/media/FooterBg.f5688203.png";